import React, {PureComponent} from 'react'
import PropTypes from 'prop-types'

import './CircleProgress.scss'

const QUART = Math.PI / 2
const CIRC = Math.PI * 2

const LINE_WIDTH = 100/15
const SIZE = 100

export default class CircleProgress extends PureComponent {
  static propTypes = {
    current: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired
  }

  ctx = null

  initCanvas = (canvas) => {
    if (!canvas) {
      return
    }

    this.ctx = Object.assign(canvas.getContext('2d'), {
      strokeStyle: '#304FFE',
      lineCap: 'square',
      lineWidth: LINE_WIDTH
    })

    this.draw()
  }

  componentDidUpdate() {
    this.draw()
  }

  draw = () => {
    const {
      ctx,
      props: {
        current,
        total
      }
    } = this
    ctx.clearRect(0, 0, SIZE, SIZE)
    if (current > 0) {
      ctx.beginPath()
      ctx.arc(SIZE/2, SIZE/2, (SIZE/2) - LINE_WIDTH, -QUART, (CIRC * (current/total)) - QUART)
      ctx.stroke()
    }
  }

  render() {
    return (
      <canvas
        styleName="circle-progress"
        ref={this.initCanvas}
        width={SIZE}
        height={SIZE}
      />
    )
  }
}
